import { Injectable } from "@angular/core";
import { AppService } from "../../../core/service/Base.Service";


@Injectable()
export class StudentbirthdayService extends AppService<any> {

    constructor() {
        super('SMMessage');
    }
}



// WEBPACK FOOTER //
// ./src/app/shell/shell-components/Student-birthday/studentbirthday.service.ts